import React from 'react';

import { StyledMenuPaper } from '@/shared/components/ui/paper/menu-paper/menu-paper.styled';
import { TMenuPaperProps } from '@/shared/components/ui/paper/menu-paper/menu-paper.types';

export const MenuPaper: React.FC<TMenuPaperProps> = ({
  anchorOrigin,
  transformOrigin,
  ...props
}) => {
  // MUI's Popover injects `ownerState` into the paper slot. styled-components
  // doesn't filter it, so drop it here to avoid leaking onto the DOM.
  const { ownerState: _ownerState, ...rest } = props as TMenuPaperProps & {
    ownerState?: unknown;
  };

  return (
    <StyledMenuPaper
      $anchorOrigin={anchorOrigin}
      $transformOrigin={transformOrigin}
      {...rest}
    />
  );
};
